import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin(() => {
  const bookingStore = useBookingStore()
  const locationStore = useLocationStore()

  // Set initial tags from hydrated state
  if (locationStore.location?.id) Sentry.setTag("location_id", locationStore.location.id)
  if (locationStore.location?.slug) Sentry.setTag("location_slug", locationStore.location.slug)
  if (bookingStore.selectedCustomer?.id) Sentry.setTag("booking_customer_id", bookingStore.selectedCustomer.id)
  if (bookingStore.selectedCustomer?.displayName) Sentry.setTag("booking_customer_name", bookingStore.selectedCustomer.displayName)

  // Subscribe to booking store changes
  bookingStore.$subscribe((mutation, state) => {
    if (state.selectedCustomer?.id) {
      Sentry.setTag("booking_customer_id", state.selectedCustomer.id)
    }
    if (state.selectedCustomer?.displayName) {
      Sentry.setTag("booking_customer_name", state.selectedCustomer.displayName)
    }
  })

  // Subscribe to location store changes
  locationStore.$subscribe((mutation, state) => {
    if (state.location?.id) {
      Sentry.setTag("location_id", state.location.id)
    }
    if (state.location?.slug) {
      Sentry.setTag("location_slug", state.location.slug)
    }
  })
})
